import { ExaminationReportImportFailureCode, ExaminationReportImportResult, } from "@pima/contracts/precautionary-index";
import { HttpApiEndpoint, HttpApiSchema } from "@effect/platform";
import * as S from "effect/Schema";
import { LanguageSchema } from "./column-schemas.js";
import { NotFound } from "./folders.js";
import { Forbidden } from "./shares.js";
export const ExaminationReportMapping = S.Struct({
    first_name: S.optional(S.NonEmptyString),
    last_name: S.optional(S.NonEmptyString),
    date_of_birth: S.optional(S.NonEmptyString),
    personal_number: S.optional(S.NonEmptyString),
    email: S.optional(S.NonEmptyString),
    examination_abbreviation: S.optional(S.NonEmptyString),
    examination_type: S.optional(S.NonEmptyString),
    examination_date: S.optional(S.NonEmptyString),
    next_examination_date: S.optional(S.NonEmptyString),
});
export const CreateExaminationReportImportParams = S.Struct({
    client_id: S.UUID,
    language: LanguageSchema,
    filename: S.NonEmptyString.pipe(S.maxLength(255)),
    mapping: S.parseJson(ExaminationReportMapping),
});
export const ExaminationReportImportState = S.Union(S.Struct({ id: S.UUID, status: S.Literal("pending"), result: S.Null }), S.Struct({
    id: S.UUID,
    status: S.Literal("completed"),
    result: ExaminationReportImportResult,
}), S.Struct({
    id: S.UUID,
    status: S.Literal("failed"),
    result: S.Struct({ code: ExaminationReportImportFailureCode }),
}));
export const CreateExaminationReportImport = HttpApiEndpoint.post("createExaminationReportImport", "/precautionary-index/imports")
    .setUrlParams(CreateExaminationReportImportParams)
    .setPayload(HttpApiSchema.Uint8Array())
    .addSuccess(S.Struct({ data: S.Struct({ id: S.UUID }) }), { status: 202 })
    .addError(Forbidden, { status: 403 })
    .addError(S.Struct({ _tag: S.Literal("ReportImportUnavailable") }), {
    status: 503,
});
export const GetExaminationReportImport = HttpApiEndpoint.get("getExaminationReportImport", "/precautionary-index/imports/:id")
    .setPath(S.Struct({ id: S.UUID }))
    .addSuccess(S.Struct({ data: ExaminationReportImportState }))
    .addError(Forbidden, { status: 403 })
    .addError(NotFound, { status: 404 });
//# sourceMappingURL=examination-report-imports.js.map